import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateTimeHelper {
  constructor() {}

  public formatTime(time: Date): string {
    return `${time.getHours() < 10 ? '0' : ''}${time.getHours()}:${
      time.getMinutes() < 10 ? '0' : ''
    }${time.getMinutes()}`;
  }

  public formatToDate(time: string) {
    return moment(time, 'HH:mm').toDate();
  }

  numberToTimeString(seconds: number): string {
    const date = new Date(0);
    date.setSeconds(seconds);
    return date.toISOString().substring(11, 19); //returs HH:MM:SS
  }

  public toDateUS(date: string) {
    return this.getCustomFormatDate('Y-m-d', date);
  }

  public millsToDays(ms: number) {
    return ms / 1000 / 60 / 60 / 24;
  }

  public daysAgo(data: Date): number {
    const today = new Date();
    const diff = today.getTime() - data.getTime();
    const oneDayInMills = 24 * 60 * 60 * 1000;
    const diffDays = Math.floor(diff / oneDayInMills);
    return diffDays;
  }

  public toDateTimeBR(date: string) {
    return this.getCustomFormatDate('d/m/Y H:i:s', date);
  }
  public setHourAndMinutesOnDate(date: Date, hourMinutes?: string /*HH:MM*/): Date {
    const result = new Date(date);
    const pair = hourMinutes?.split(':');
    if (pair && pair.length > 1) {
      result.setHours(parseInt(pair[0]));
      result.setMinutes(parseInt(pair[1]));
      result.setSeconds(0);
    }
    return result;
  }

  public toDateBR(date: string) {
    return this.getCustomFormatDate('d/m/Y H:i:s', date);
  }

  public convertSecondsToMinutes(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  public convertDateToSeconds(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const totalSeconds = hours * 60 + minutes;
    return totalSeconds;
  }
  public convertSecondsToDate(seconds: number) {
    const time = this.convertSecondsToMinutes(seconds);
    return moment(time, 'HH:mm').toDate();
  }

  public msToHMS(ms: number) {
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  public getCustomFormatDate(format: string = 'Y-m-d H:i:s', date: string = '') {
    const _date = !date ? new Date() : new Date(date);

    while (new RegExp('Y|m|d|H|i|s').test(format)) {
      format = format
        .replace('Y', String(_date.getFullYear()))
        .replace('m', this.completeLeftZero(_date.getMonth() + 1))
        .replace('d', this.completeLeftZero(_date.getDate()))
        .replace('H', this.completeLeftZero(_date.getHours()))
        .replace('i', this.completeLeftZero(_date.getMinutes()))
        .replace('s', this.completeLeftZero(_date.getSeconds()));
    }
    return format;
  }

  private completeLeftZero(obj: number | string) {
    return String(<number>obj < 10 ? '0' + String(obj) : obj);
  }

  public startOfDay(dt: Date): Date {
    const result = dt;
    if (dt instanceof Date) {
      result.setHours(0);
      result.setSeconds(0);
      result.setMinutes(0);
    }
    return result;
  }

  public endOfDay(dt: Date): Date {
    const result = dt;
    if (dt instanceof Date) {
      result.setHours(23);
      result.setSeconds(59);
      result.setMinutes(59);
    }
    return result;
  }
  public startOfMonth(dt: Date): Date {
    const result = dt;
    result.setHours(0);
    result.setSeconds(1);
    result.setMinutes(0);
    result.setDate(1);

    return result;
  }

  public endOfMonth(dt: Date): Date {
    const result = dt;
    result.setHours(23);
    result.setSeconds(59);
    result.setMinutes(59);
    result.setMonth(result.getMonth() + 1);
    result.setDate(-1);

    return result;
  }

  public getDateToReport(date: string) {
    const language = navigator.language || 'pt-BR';

    return new Date(date).toLocaleString(language);
  }

  public getTimeISO(): string {
    return new Date().toISOString();
  }

  public getTimeMS(dataISO: string): string {
    return new Date(dataISO).getTime().toString();
  }

  public getTimeSIP(time: string) {
    const getDuration =
      String(new Date(Number(time)).getMinutes()).padStart(2, '0') +
      ':' +
      String(new Date(Number(time)).getSeconds()).padStart(2, '0');

    return getDuration;
  }

  public getDateSIP(date: string) {
    const getDate =
      String(new Date(Number(date)).getDate()).padStart(2, '0') +
      '/' +
      String(new Date(Number(date)).getMonth() + 1).padStart(2, '0') +
      '/' +
      new Date(Number(date)).getFullYear() +
      ' ' +
      String(new Date(Number(date)).getHours()).padStart(2, '0') +
      ':' +
      String(new Date(Number(date)).getMinutes()).padStart(2, '0') +
      ':' +
      String(new Date(Number(date)).getSeconds()).padStart(2, '0');

    return getDate;
  }

  public getStartAndEndDay(date?: Date): { startDate: string; endDate: string } {
    const startDate = date ? new Date(date) : new Date();
    const endDate = date ? new Date(date) : new Date();

    startDate.setHours(0, 0, 0);
    endDate.setHours(23, 59, 59);

    return {
      startDate: this.toDateUS(startDate.toString()),
      endDate: this.toDateUS(endDate.toString()),
    };
  }

  public getDataAtualBrasilia(date: any) {
    const dataAtual = new Date(date);

    const offsetBrasilia = -3 * 60 * 60 * 1000;
    const offsetLocal = dataAtual.getTimezoneOffset() * 60 * 1000;

    if (offsetBrasilia !== offsetLocal * -1) {
      return new Date(dataAtual.getTime() + offsetLocal + offsetBrasilia);
    }
    return dataAtual;
  }

  getMonthNameDate(date: string, locale: string = 'pt-BR') {
    const [day, month, year] = date.split('/');
    const currentDate = new Date(parseInt(year), parseInt(month), parseInt(day));
    return currentDate.toLocaleString(locale, { month: 'long' });
  }

  formatDateUS(date) {
    if (typeof date === 'string') {
      date = new Date(date);
    } else if (typeof date === 'object') {
      date = new Date(date.toISOString());
    }
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    return utcDate.toISOString().split('T')[0];
  }

  formatSeconds(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
  }

  private pad(num: number): string {
    return String(num).padStart(2, '0');
  }

  // 01:30 -> 90 minutes
  public timeStringToMinutes(time: String) {
    if (!time) {
      return 0;
    }

    const [hours, minutes] = time.split(':').map(Number);

    return hours * 60 + minutes;
  }

  // 90 minutes -> 01:30
  public minutesToTimeString(minutes: number) {
    const hrs = Math.floor(minutes / 60)
      .toString()
      .padStart(2, '0');
    const min = (minutes % 60).toString().padStart(2, '0');

    return `${hrs}:${min}`;
  }

  // 1920-02-24 -> 24/02/1920
  public convertUSDateToBR(dateString: string): string {
    if (!dateString || typeof dateString !== 'string') {
      return dateString;
    }

    const [year, month, day] = dateString.split('-');
    const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);
    const dayNum = parseInt(day, 10);

    if (!yearNum || !monthNum || !dayNum) {
      return dateString;
    }

    return `${day}/${month}/${year}`;
  }

  // 90 -> 1min30s
  public secondsToMinSec(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds}s`;
    }

    if (remainingSeconds === 0) {
      return `${minutes}min`;
    }

    return `${minutes}min${remainingSeconds}s`;
  }

  public formatDateTimeToBR(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
}
